import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Header = ({ createNeeded }: { createNeeded: boolean }) => {
  if (createNeeded) {
    return (
      <FormattedMessage
        id="account.creation.confirmation.title"
        defaultMessage="Create your account"
        description="Title of form for creating an account"
        tagName="h5"
      />
    );
  } else {
    return (
      <FormattedMessage
        id="account.verification.title"
        defaultMessage="Verify your email"
        description="Title of form for verifying an account"
        tagName="h5"
      />
    );
  }
};
